import { render, staticRenderFns } from "./CustomerResearch.vue?vue&type=template&id=654995cf&scoped=true&"
import script from "./CustomerResearch.vue?vue&type=script&lang=js&"
export * from "./CustomerResearch.vue?vue&type=script&lang=js&"
import style0 from "./CustomerResearch.vue?vue&type=style&index=0&id=654995cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654995cf",
  null
  
)

export default component.exports